import {Pipe, PipeTransform} from '@angular/core';
import {IHourTable} from '../../models/timetable';

@Pipe({
  name: 'convertHourTable'
})
export class ConvertHourTablePipe implements PipeTransform {

  transform(value: IHourTable, type: 'start' | 'end'): Date {
    const date = new Date();
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      type === 'start' ? value.startHour : value.endHour,
      type === 'start' ? value.startMinutes : value.endMinutes
    );
  }
}
